import { render, staticRenderFns } from "./feedback-dialog.vue?vue&type=template&id=771ac6a2&"
import script from "./feedback-dialog.vue?vue&type=script&lang=js&"
export * from "./feedback-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "feedback-dialog.vue"
export default component.exports